import React, { Component, Fragment, createRef } from 'react';
import { NOT_REGISTERED, REGISTERED } from './SessionActions';
import classnames from 'classnames';
import { SAVE_A_SEAT_FAILED_TEXT, REMOVE_SEAT_FAILED_TEXT } from '../../../constants/Enums';
import {
    sendCustomClick
} from '../../../utils/SnowplowUtils';
import {
    saveASeatSubCategory,
    buttonTypes
} from '../../../constants/SnowplowConst';

const unRegisteredOptions = {
    text: 'Save a seat for this session?',
    negativeActionText: 'cancel',
    positiveActionText: 'save',
    actionDoneText: 'Seat Saved!'
};
const registeredOptions = {
    text: 'Remove this session from your schedule?',
    negativeActionText: 'keep',
    positiveActionText: 'remove',
    actionDoneText: 'Session Removed'
};

export default class SessRegPopover extends Component {

    state = {
        loading: false,
        loadingDone: false,
        options: {},
        error: null,
        errorIcon: null
    };

    activeButtonRef = createRef();

    componentDidMount() {
        const { initialState } = this.props;
        this.setState({ options: initialState === REGISTERED ? registeredOptions : unRegisteredOptions});
    }

    sendSPSaveASeatClick = () => {
        const subCategory = this.props.initialState === NOT_REGISTERED
            ? saveASeatSubCategory.singleSaveASeatPopUp
            : saveASeatSubCategory.removeSingleSaveASeatPopUp;
        sendCustomClick(buttonTypes.saveSeat, subCategory, this.activeButtonRef);
    }

    sessionRegistrationClickHandler = async() => {
        this.sendSPSaveASeatClick();
        const {
            action, initialState, sessionId, isAuthorized, onDone, addSessionOnSaveSeatClick,
            setSessionFullRegistration, ticketId
        } = this.props;
        const toRegister = initialState === NOT_REGISTERED;
        if (isAuthorized) {
            try {
                toRegister && addSessionOnSaveSeatClick(sessionId, ticketId);
                this.setState({ loading: true });
                await action(sessionId, toRegister, ticketId);
                this.setState({ loadingDone: true });
            } catch (e) {
                if (e?.errorCode === 'session_registration_error' && e?.message === 'Session capacity reached'){
                    this.setState({
                        loadingDone: true,
                        error: 'This session has reached it\'s capacity limit',
                        errorIcon: 'icon-Chair_Overlap'
                    });
                } else if (e?.errorCode === 'session_registration_error' && e?.message === 'session overlapping between old and new selected sessions is not allowed') {
                    this.setState({
                        loadingDone: true,
                        error: 'This session overlaps with a session you are already registered for.',
                        errorIcon: 'icon-Chair_Overlap'
                    });
                } else {
                    this.setState({
                        loadingDone: true,
                        error: toRegister ? SAVE_A_SEAT_FAILED_TEXT : REMOVE_SEAT_FAILED_TEXT,
                        errorIcon: 'icon-Chair_Overlap'
                    });
                }
            } finally {
                setTimeout(() => onDone(), 1500);
            }
        }
    };

    render() {
        const { onDone, initialState } = this.props;
        const {
            options: {
                negativeActionText,
                text,
                positiveActionText,
                actionDoneText
            },
            loading,
            loadingDone,
            error,
            errorIcon
        } = this.state;
        const containerCls = classnames('circle-loader', { 'load-complete': loadingDone });
        const textCls = classnames({'short': initialState === NOT_REGISTERED});
        const clsIcon = classnames({[errorIcon]: error}, {'checkmark': !error}, 'draw');
        const sessionPopUpCls = classnames('session-action-popup', {'loaded': !loading });
        return (
            <div className={sessionPopUpCls}>
                {
                    (loading || error) && <Fragment>
                        <div className={containerCls}>
                            <div className={clsIcon} style={{display: loadingDone ? 'block' : 'none'}} />
                        </div>
                        { loadingDone && <div className='done-text'>{error ? error : actionDoneText}</div> }
                    </Fragment>
                }
                {
                    !loading && <Fragment>
                        <h3 className={textCls}>{text}</h3>
                        <div>
                            <button
                                onClick={onDone}
                                className='negative-button custom-color color-1-border color-1'>
                                {negativeActionText}
                            </button>
                            <button
                                onClick={this.sessionRegistrationClickHandler}
                                ref={this.activeButtonRef}
                                className='positive-button custom-color color-1-border color-1-background'>
                                {positiveActionText}
                            </button>
                        </div>
                    </Fragment>
                }
            </div>
        );
    }

}
